export const defaultAmountDisplay = { min: 0, max: 100000 }
